// src/redux/reducers/Settings.js
import { SET_SETTINGS } from "redux/actions/Settings";

const initialState = {
  locale: "en",     // default to English
  direction: "ltr", // default to left-to-right
};

export default function settings(state = initialState, action) {
  switch (action.type) {
    case SET_SETTINGS:
      return { ...state, ...action.payload };
    default:
      return state;
  }
}
